module.exports = __webpack_public_path__ + "media/ca_slide3_video.840ad356.mp4";